import map from "lodash/map";
import { ContentFormatV7 } from "../v7/content_format";
import {
  ContentConditionV7,
  TemplateConditionFormatV7,
  TemplateFormatV7,
} from "../v7/template_format";
import { ContentFormatV8 } from "../v8/content_format";
import {
  ContentConditionV8,
  TemplateConditionFormatV8,
  TemplateFormatV8,
} from "../v8/template_format";

export function upgradeContentToV8(contentFormat: ContentFormatV7): ContentFormatV8 {
  const contentV8: ContentFormatV8 = {
    ...contentFormat,
    definition_version: 8,

    pages: map(contentFormat.pages, (pageContent) => {
      return pageContent;
    }),
  };

  if (contentV8.template_type === "book" && contentFormat.template_type === "book") {
    contentV8.title = contentFormat.book_title;
    contentV8.title_font_key = contentFormat.book_title_font_key;
  }

  return contentV8;
}

export function upgradeTemplateToV8(templateFormat: TemplateFormatV7): TemplateFormatV8 {
  const templateV8 = {
    ...templateFormat,
    definition_version: 8,

    color_definitions: templateFormat.color_definitions.map((colorDefinition) => {
      return {
        font_colors: colorDefinition.font_colors,
        key: colorDefinition.key,
        background_value: colorDefinition.value,
      };
    }),

    page_definitions: templateFormat.page_definitions.map((definition) => {
      const conditionsV7ToV8 = (
        conditions: Array<ContentConditionV7 | TemplateConditionFormatV7>
      ): Array<ContentConditionV8 | TemplateConditionFormatV8> => {
        return conditions.map((condition) => {
          if (condition.type === "content") {
            const currentCondition = condition as ContentConditionV7;
            return {
              ...currentCondition,
              variable:
                currentCondition.variable === "book_title" ? "title" : currentCondition.variable,
            } as ContentConditionV8;
          }
          const currentCondition = condition as TemplateConditionFormatV7;
          return currentCondition as TemplateConditionFormatV8;
        });
      };

      return {
        ...definition,
        elements: definition.elements.map((element) => {
          if (element.type === "forced-text" && element.interpolated_content === "book_title") {
            return {
              ...element,
              conditions: element.conditions
                ? conditionsV7ToV8(element.conditions)
                : element.conditions,
              interpolated_content: "title",
            };
          }
          return {
            ...element,
            conditions: element.conditions
              ? conditionsV7ToV8(element.conditions)
              : element.conditions,
          };
        }),
        conditions: definition.conditions
          ? conditionsV7ToV8(definition.conditions)
          : definition.conditions,
      };
    }),
    page_mode:
      templateFormat.template_type === "book"
        ? templateFormat.page_mode === "single"
          ? "single_horizontal"
          : templateFormat.page_mode
        : undefined,
  };

  return templateV8 as TemplateFormatV8;
}
